// Checklist - PAVADINIMAS (puslapis)

page.checklist.MarketSP = {
    enabled: false,
    ready: false,
    needsLoad: false,
    progress: 0,
    scene: null,
    check: function(){ // Šitą funkciją vykdo kai tikrina užkrauto puslapio DOM, ieško elementų
        this.reset();
        if(page.v.firstLoad) this.first(); // Pirmą kart užkrovus tinklapį galima susikurti kažkokius pastovius kintamuosius ir t.t.

        if($('.section-grain').length > 0){ // jei randi reikiamą elementą - modulis įjungiamas.
            log.page("CHECK: MARKETS (supirkimo punktai) detected", 2);
            this.enabled = true;
        }
    },
    reset: function(){
        this.enabled = false;
        this.ready = false;
        this.needsLoad = false;
        this.progress = 0;
    },
    init: function(){ // Ši funkcija vykdoma iškart po DOM apdorojimo, galima kabint eventus ir t.t.
        let name = $('.barba-container').data('namespace');
        page.transitions(name, 900);

        page.main.fr.buyingPoints.ajax();
        page.main.v.marketSticky.play(0);
        page.main.fr.tooltipster.init();
        page.main.fr.altMenu.default();
        page.main.fr.floatLabels.init();
        $('.scrollto').click(function(e){
            e.preventDefault();
            let target = $(this).data('target');
            $('html, body').animate({
                scrollTop:$(target).offset().top - 20
            }, 700);
        })

        let sticky = $('.g-map-managers');
        let contr = page.main.fr.magicScroll.controller;
        let scene = new ScrollMagic.Scene(
            {
                triggerElement: sticky[0],
                duration: sticky.outerHeight(),
                triggerHook: 0.1
            })
            .addTo(contr);

        scene.on('start', function(event){

            if($('.g-map-managers').hasClass('active') && event.scrollDirection == 'FORWARD'){
                TweenMax.set($('.header-logo').find('a'),{autoAlpha: 0});
            }
            if(event.scrollDirection == 'REVERSE'){
                TweenMax.set($('.header-logo').find('a'),{autoAlpha: 1});
            }

        });
        scene.on("progress", function (event) {
            if($('.g-map-managers').hasClass('active')){
                TweenMax.set($('.header-logo').find('a'),{autoAlpha: 0});
            }else{
                TweenMax.set($('.header-logo').find('a'),{autoAlpha: 1});
            }

        });
        scene.on('end', function(event){

            if($('.g-map-managers').hasClass('active') && event.scrollDirection == 'FORWARD'){
                TweenMax.set($('.header-logo').find('a'),{autoAlpha: 1});
            }
            if(event.scrollDirection == 'REVERSE'){
                TweenMax.set($('.header-logo').find('a'),{autoAlpha: 0});
            }
        });

        page.checklist.Buying.scene = scene;


        let hash = window.location.hash;

        if(hash){
            $('html, body').animate({
                scrollTop: $(hash.replace('%C5%B3', 'ų')).offset().top - 50
            }, 800);
        }

        this.resize();
    },

    first: function(){ // Ši funkcija vykdoma pirmą kartą užkrovus tinklapį
      //  page.main.fr.managerMap.destroy();
      //  page.main.fr.cvUpload.destroy();
      //  page.main.fr.floatLabels.destroy();

    },
    unload: function(){ // Ši funkcija skirta išvalyti eventams prieš nukraunant puslapį per ajax.
        page.main.fr.buyingPoints.destroy();
        page.main.fr.tooltipster.destroy();
        page.checklist.Buying.scene.destroy($('.g-map-managers'));
        page.checklist.Buying.scene = null;
        page.main.fr.floatLabels.destroy();

    },
    calc: function(){ // Ši funkcija vykdoma kiekvieno kadro metu (animacijoms ir t.t.)

    },
    resize: function(){ // onResize funkcija (pati administruojasi, nereikia atrišinėti)

    },
    scroll: function(){ // onScroll funkcija (pati administruojasi)

    },
    v: {
        // Jei reikalingi vidiniai kintamieji programos darbui, kurie turi išlikti tarp funkcijų vydymo
    },
    f: {
        // Jei reikalingos papildomos vidinės funkcijos modulio veikimui
    }
}